import { useState, useCallback, MouseEvent } from 'react';

type TSetPopperIsOpen = (open: boolean, event?: MouseEvent<HTMLElement>) => void

export interface IUsePopperReturn {
  isOpen: boolean,
  anchorEl: HTMLElement | null,
  setPopperIsOpen: TSetPopperIsOpen
}

const usePopper = () : IUsePopperReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const setPopperIsOpen = useCallback<TSetPopperIsOpen>((open, event) => {
    if (open && !event && !anchorEl) {
      throw new Error(
        'The \'anchorEl\' isn\'t initialized. Please initialize it on the first opening.',
      );
    }
    setIsOpen(open);
    if (open && event) {
      setAnchorEl(event.currentTarget);
    }
  }, [anchorEl]);

  return { isOpen, anchorEl, setPopperIsOpen };
};

export default usePopper;
